import { put, takeEvery } from 'redux-saga/effects';
import { actions as applicationActions } from 'wpt-duck-application';
import { types as envTypes } from 'wpt-duck-env';

function* envSet() {
  yield put(applicationActions.ready());
}

function* mainSaga() {
  yield takeEvery([envTypes.SET], envSet);
}

export default mainSaga;
